import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import SlabBreakdownTable from 'componentsv2/common/SlabBreakdownTable';

/**
 * The slab walk behind a shipment count, opened from the count itself.
 *
 * The table is shared with the Client Invoice generation step
 * (componentsv2/common/SlabBreakdownTable) so both read identically.
 */
export default function SlabBreakdownModal({ open, title, breakdown, shipmentCount, onClose }) {
	return (
		<Modal open={open} title={title} footer={null} width={620} onCancel={onClose}>
			<SlabBreakdownTable breakdown={breakdown} shipmentCount={shipmentCount} />
		</Modal>
	);
}

SlabBreakdownModal.propTypes = {
	open: PropTypes.bool,
	title: PropTypes.string.isRequired,
	breakdown: PropTypes.array,
	shipmentCount: PropTypes.number,
	onClose: PropTypes.func.isRequired,
};

SlabBreakdownModal.defaultProps = {
	open: false,
	breakdown: [],
	shipmentCount: 0,
};
